import React, { PropsWithChildren, useRef } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Popover from "@src/sharedComponents/Popover/Popover";

import styles from "./CustomDropdownBase.module.css";

interface Props {
  popoverElement: React.ReactNode;
  showDropdown: boolean;
  closeDropdown: () => void;
  menuWidth?: number;
  className?: string;
}

const CustomDropdownPopoverBase: React.FC<PropsWithChildren<Props>> = ({
  popoverElement,
  showDropdown,
  closeDropdown,
  menuWidth,
  children,
  className,
}: PropsWithChildren<Props>) => {
  const anchorRef = useRef<HTMLDivElement | null>(null);

  return (
    <Popover
      open={showDropdown}
      onClose={closeDropdown}
      anchor={anchorRef.current}
      transformOriginVertical={-10}
      popoverElement={<div ref={anchorRef}>{popoverElement}</div>}
    >
      <div
        className={toClassName(styles.menu, className)}
        style={menuWidth ? { width: `${menuWidth}px` } : {}}
      >
        {children}
      </div>
    </Popover>
  );
};

export default CustomDropdownPopoverBase;
